// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13Dnp","buttons":"styles_buttons__3wMlH"};